import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    regionIpsAdminControllerListRegionIpsV1: build.query<
      RegionIpsAdminControllerListRegionIpsV1ApiResponse,
      RegionIpsAdminControllerListRegionIpsV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/regions/${queryArg.id}/ips`,
      }),
    }),
    regionIpsAdminControllerCreateRegionIpV1: build.mutation<
      RegionIpsAdminControllerCreateRegionIpV1ApiResponse,
      RegionIpsAdminControllerCreateRegionIpV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/regions/${queryArg.id}/ips`,
        method: 'POST',
        body: queryArg.createRegionIpBody,
      }),
    }),
    regionIpsAdminControllerUpdateRegionIpV1: build.mutation<
      RegionIpsAdminControllerUpdateRegionIpV1ApiResponse,
      RegionIpsAdminControllerUpdateRegionIpV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/regions/${queryArg.id}/ips/${queryArg.ipId}`,
        method: 'PUT',
        body: queryArg.updateRegionIpBody,
      }),
    }),
    regionIpsAdminControllerDeleteRegionIpV1: build.mutation<
      RegionIpsAdminControllerDeleteRegionIpV1ApiResponse,
      RegionIpsAdminControllerDeleteRegionIpV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/regions/${queryArg.id}/ips/${queryArg.ipId}`,
        method: 'DELETE',
      }),
    }),
    regionsAdminControllerCreateRegionV1: build.mutation<
      RegionsAdminControllerCreateRegionV1ApiResponse,
      RegionsAdminControllerCreateRegionV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/regions`,
        method: 'POST',
        body: queryArg.createRegionBody,
      }),
    }),
    regionsAdminControllerListRegionsV1: build.query<
      RegionsAdminControllerListRegionsV1ApiResponse,
      RegionsAdminControllerListRegionsV1ApiArg
    >({
      query: () => ({ url: `/api/v1/admin/regions` }),
    }),
    regionsAdminControllerGetRegionV1: build.query<
      RegionsAdminControllerGetRegionV1ApiResponse,
      RegionsAdminControllerGetRegionV1ApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/admin/regions/${queryArg.id}` }),
    }),
    regionsAdminControllerUpdateRegionV1: build.mutation<
      RegionsAdminControllerUpdateRegionV1ApiResponse,
      RegionsAdminControllerUpdateRegionV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/regions/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateRegionBody,
      }),
    }),
    regionsAdminControllerDeleteRegionV1: build.mutation<
      RegionsAdminControllerDeleteRegionV1ApiResponse,
      RegionsAdminControllerDeleteRegionV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/regions/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type RegionIpsAdminControllerListRegionIpsV1ApiResponse =
  /** status 200 Returns the IP addresses of the region */ ListRegionIpsResponse;
export type RegionIpsAdminControllerListRegionIpsV1ApiArg = {
  id: number;
};
export type RegionIpsAdminControllerCreateRegionIpV1ApiResponse =
  /** status 200 Returns the created IP address */ CreateRegionIpResponse;
export type RegionIpsAdminControllerCreateRegionIpV1ApiArg = {
  id: number;
  createRegionIpBody: CreateRegionIpBody;
};
export type RegionIpsAdminControllerUpdateRegionIpV1ApiResponse =
  /** status 200 Returns the updated IP address */ UpdateRegionIpResponse;
export type RegionIpsAdminControllerUpdateRegionIpV1ApiArg = {
  id: number;
  ipId: number;
  updateRegionIpBody: UpdateRegionIpBody;
};
export type RegionIpsAdminControllerDeleteRegionIpV1ApiResponse =
  /** status 200 Returns the deleted IP address */ DeleteRegionIpResponse;
export type RegionIpsAdminControllerDeleteRegionIpV1ApiArg = {
  id: number;
  ipId: number;
};
export type RegionsAdminControllerCreateRegionV1ApiResponse =
  /** status 200 Returns created region */ CreateRegionResponse;
export type RegionsAdminControllerCreateRegionV1ApiArg = {
  createRegionBody: CreateRegionBody;
};
export type RegionsAdminControllerListRegionsV1ApiResponse =
  /** status 200 Returns the list of regions */ ListRegionsResponse;
export type RegionsAdminControllerListRegionsV1ApiArg = void;
export type RegionsAdminControllerGetRegionV1ApiResponse =
  /** status 200 Region details */ GetRegionResponse;
export type RegionsAdminControllerGetRegionV1ApiArg = {
  id: number;
};
export type RegionsAdminControllerUpdateRegionV1ApiResponse =
  /** status 200 Returns updated region */ UpdateRegionResponse;
export type RegionsAdminControllerUpdateRegionV1ApiArg = {
  id: number;
  updateRegionBody: UpdateRegionBody;
};
export type RegionsAdminControllerDeleteRegionV1ApiResponse =
  /** status 200 Returns deleted region */ DeleteRegionResponse;
export type RegionsAdminControllerDeleteRegionV1ApiArg = {
  id: number;
};
export type ListRegionIpsResponse = {
  /** IP address ID */
  id: number;
  /** A single IPv4 or IPv6 address */
  address: string;
  /** Owning region, when the IP belongs to a region */
  regionId: null | number;
  /** Owning exchange, when the IP belongs to an exchange */
  exchangeId: null | number;
  /** Transport an exchange-owned IP serves; null for region-owned IPs, which take their transport from the exchange-region link */
  usage: null | string;
  /** Whether this IP is used by the monitoring system */
  isMonitoring: boolean;
  /** Whether this IP is exposed to clients via the API */
  isApi: boolean;
  /** Whether this IP is used by the trading bot */
  isTrading: boolean;
  /** Free-text admin note on what this IP is for; null when unset. Trimmed on write, and an empty or blank note is stored as null. Admin-only: never returned by the public or RPC IP lists */
  description: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
}[];
export type ForbiddenError = {
  statusCode: number;
  error?: string;
  /** Localized, human-readable */
  message: string;
  /** The i18n key of the error, stable across languages */
  code: string;
};
export type CreateRegionIpResponse = {
  /** IP address ID */
  id: number;
  /** A single IPv4 or IPv6 address */
  address: string;
  /** Owning region, when the IP belongs to a region */
  regionId: null | number;
  /** Owning exchange, when the IP belongs to an exchange */
  exchangeId: null | number;
  /** Transport an exchange-owned IP serves; null for region-owned IPs, which take their transport from the exchange-region link */
  usage: null | string;
  /** Whether this IP is used by the monitoring system */
  isMonitoring: boolean;
  /** Whether this IP is exposed to clients via the API */
  isApi: boolean;
  /** Whether this IP is used by the trading bot */
  isTrading: boolean;
  /** Free-text admin note on what this IP is for; null when unset. Trimmed on write, and an empty or blank note is stored as null. Admin-only: never returned by the public or RPC IP lists */
  description: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
export type BadRequestError = {
  statusCode: number;
  error?: string;
  /** Localized, human-readable */
  message: string;
  /** The i18n key of the error, stable across languages */
  code: string;
  /** On BAD_REQUEST_VALIDATION: one entry per failed field */
  errors?: {
    path: string;
    message: string;
    [key: string]: any;
  }[];
};
export type CreateRegionIpBody = {
  /** A single IPv4 or IPv6 address */
  address: string;
  /** Whether this IP is used by the monitoring system */
  isMonitoring?: boolean;
  /** Whether this IP is exposed to clients via the API */
  isApi?: boolean;
  /** Whether this IP is used by the trading bot */
  isTrading?: boolean;
  /** Free-text admin note on what this IP is for; null when unset. Trimmed on write, and an empty or blank note is stored as null. Admin-only: never returned by the public or RPC IP lists */
  description?: null | string;
};
export type UpdateRegionIpResponse = {
  /** IP address ID */
  id: number;
  /** A single IPv4 or IPv6 address */
  address: string;
  /** Owning region, when the IP belongs to a region */
  regionId: null | number;
  /** Owning exchange, when the IP belongs to an exchange */
  exchangeId: null | number;
  /** Transport an exchange-owned IP serves; null for region-owned IPs, which take their transport from the exchange-region link */
  usage: null | string;
  /** Whether this IP is used by the monitoring system */
  isMonitoring: boolean;
  /** Whether this IP is exposed to clients via the API */
  isApi: boolean;
  /** Whether this IP is used by the trading bot */
  isTrading: boolean;
  /** Free-text admin note on what this IP is for; null when unset. Trimmed on write, and an empty or blank note is stored as null. Admin-only: never returned by the public or RPC IP lists */
  description: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
export type UpdateRegionIpBody = {
  /** A single IPv4 or IPv6 address */
  address?: string;
  /** Whether this IP is used by the monitoring system */
  isMonitoring?: boolean;
  /** Whether this IP is exposed to clients via the API */
  isApi?: boolean;
  /** Whether this IP is used by the trading bot */
  isTrading?: boolean;
  /** Free-text admin note on what this IP is for; null when unset. Trimmed on write, and an empty or blank note is stored as null. Admin-only: never returned by the public or RPC IP lists */
  description?: null | string;
};
export type DeleteRegionIpResponse = {
  /** IP address ID */
  id: number;
  /** A single IPv4 or IPv6 address */
  address: string;
  /** Owning region, when the IP belongs to a region */
  regionId: null | number;
  /** Owning exchange, when the IP belongs to an exchange */
  exchangeId: null | number;
  /** Transport an exchange-owned IP serves; null for region-owned IPs, which take their transport from the exchange-region link */
  usage: null | string;
  /** Whether this IP is used by the monitoring system */
  isMonitoring: boolean;
  /** Whether this IP is exposed to clients via the API */
  isApi: boolean;
  /** Whether this IP is used by the trading bot */
  isTrading: boolean;
  /** Free-text admin note on what this IP is for; null when unset. Trimmed on write, and an empty or blank note is stored as null. Admin-only: never returned by the public or RPC IP lists */
  description: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
export type CreateRegionResponse = {
  /** Region ID */
  id: number;
  /** Region name (2-20 chars, letters, numbers, underscores, hyphens) */
  name: string;
  /** The region's IP addresses, comma-separated, or null when it has none */
  ips?: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
export type CreateRegionBody = {
  /** Region name (2-20 chars, letters, numbers, underscores, hyphens) */
  name: string;
};
export type ListRegionsResponse = {
  /** Region ID */
  id: number;
  /** Region name (2-20 chars, letters, numbers, underscores, hyphens) */
  name: string;
  /** The region's IP addresses, comma-separated, or null when it has none */
  ips?: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
}[];
export type GetRegionResponse = {
  /** Region ID */
  id: number;
  /** Region name (2-20 chars, letters, numbers, underscores, hyphens) */
  name: string;
  /** The region's IP addresses, comma-separated, or null when it has none */
  ips?: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
export type UpdateRegionResponse = {
  /** Region ID */
  id: number;
  /** Region name (2-20 chars, letters, numbers, underscores, hyphens) */
  name: string;
  /** The region's IP addresses, comma-separated, or null when it has none */
  ips?: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
export type UpdateRegionBody = {
  /** Region name (2-20 chars, letters, numbers, underscores, hyphens) */
  name?: string;
};
export type DeleteRegionResponse = {
  /** Region ID */
  id: number;
  /** Region name (2-20 chars, letters, numbers, underscores, hyphens) */
  name: string;
  /** The region's IP addresses, comma-separated, or null when it has none */
  ips?: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
};
